exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3jiUZdowzzzEmfcsUKaUUm{text-align:center;padding:40px}\n", ""]);

// Exports
exports.locals = {
	"LoadableCentered": "_3jiUZdowzzzEmfcsUKaUUm"
};